import { Search, User } from "lucide-react";

export default function Topbar() {
  return (
    <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-6">
      {/* Busca global (futuro) */}
      <div className="flex items-center gap-2 bg-slate-100 px-3 py-2 rounded-lg w-96">
        <Search size={18} className="text-slate-500" />
        <input
          placeholder="Buscar OS, cliente, placa..."
          className="bg-transparent outline-none text-sm w-full"
        />
      </div>

      {/* Usuário */}
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-blue-700 flex items-center justify-center text-white">
          <User size={18} />
        </div>
        <div className="text-sm">
          <p className="font-medium text-slate-900">Administrador</p>
          <p className="text-xs text-slate-500">Auto Mecânica</p>
        </div>
      </div>
    </header>
  );
}
